import { render, staticRenderFns } from "./UserRecordList.vue?vue&type=template&id=baa510f6&scoped=true&"
import script from "./UserRecordList.vue?vue&type=script&lang=js&"
export * from "./UserRecordList.vue?vue&type=script&lang=js&"
import style0 from "./UserRecordList.vue?vue&type=style&index=0&id=baa510f6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "baa510f6",
  null
  
)

export default component.exports